import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportServiceBase } from './custom-report/custom-report-base.service';
import {
    BoxResultType,
    ChangeOrdersClient,
    CustomReportChangeOrderView,
    GetChangeOrdersColumnChartValuesResultType,
    GetChangeOrdersLineChartValuesResultType,
    GetChangeOrdersMetricsFormattedValuesResultType,
    GetChangeOrdersValuesParameters,
    GetExternalChangeOrderValuesResultType,
    ReportResultColumnDto,
    SharedReportDto
} from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ChangeOrderService extends CustomReportServiceBase<ChangeOrdersClient, CustomReportChangeOrderView> {
    constructor(protected override client: ChangeOrdersClient) {
        super(client);
    }

    async getChangeOrdersValues(
        parameters: GetChangeOrdersValuesParameters
    ): Promise<GetExternalChangeOrderValuesResultType[]> {
        return await lastValueFrom(this.client.changeOrdersGetChangeOrdersValues(parameters));
    }

    async getChangeOrdersMetricsValues(
        parameters: GetChangeOrdersValuesParameters
    ): Promise<GetChangeOrdersMetricsFormattedValuesResultType> {
        return await lastValueFrom(this.client.changeOrdersGetChangeOrdersMetricsValues(parameters));
    }

    async getChangeOrdersBoxesValues(parameters: GetChangeOrdersValuesParameters): Promise<BoxResultType[]> {
        return await lastValueFrom(this.client.changeOrdersGetChangeOrdersBoxesValues(parameters));
    }

    async getColumnChartValues(
        parameters: GetChangeOrdersValuesParameters
    ): Promise<GetChangeOrdersColumnChartValuesResultType[]> {
        return await lastValueFrom(this.client.changeOrdersGetChangeOrdersColumnChartValues(parameters));
    }

    async getLineChartValues(
        parameters: GetChangeOrdersValuesParameters
    ): Promise<GetChangeOrdersLineChartValuesResultType[]> {
        return await lastValueFrom(this.client.changeOrdersGetChangeOrdersLineChartValues(parameters));
    }

    override async saveCustomReport(body: CustomReportChangeOrderView): Promise<CustomReportChangeOrderView> {
        if (body.isPublic) return await lastValueFrom(this.client.changeOrdersSaveCatalogReport(body));
        else return await lastValueFrom(this.client.changeOrdersSaveCustomReport(body));
    }

    override async getCustomReport(id: number): Promise<CustomReportChangeOrderView> {
        return await lastValueFrom(this.client.changeOrdersGetCustomReport(id));
    }

    override async shareReport(body: CustomReportChangeOrderView): Promise<SharedReportDto> {
        return await lastValueFrom(this.client.changeOrdersCreateSharedReport(body));
    }

    override async getSharedReport(id: string): Promise<CustomReportChangeOrderView> {
        return await lastValueFrom(this.client.changeOrdersGetSharedReport(id));
    }

    override async getResultAvailableColumns(organizationIds: number[]): Promise<ReportResultColumnDto[]> {
        return await lastValueFrom(this.client.changeOrdersResultAvailableColumns(organizationIds));
    }
}
